import { pubsub } from '@services';

class StickyAddToCart extends HTMLElement {
  connectedCallback() {
    this.observeProductForm();

    this.unsubscribeVariantChange = pubsub.subscribe(
      `variant:changed:${this.dataset.productId}`,
      ({ html }) => {
        this.handleVariantChange(html);
        this.observeProductForm();
      }
    );
  }

  disconnectedCallback() {
    this.unsubscribeVariantChanged();
  }

  /**
   * Handle variant changes.
   * @param {HTMLElement} html - The HTML to render.
   */
  handleVariantChange(html) {
    const stickyAddToCart = html.querySelector('sticky-add-to-cart');
    this.innerHTML = stickyAddToCart.innerHTML;
  }

  /**
   * Observe the product form.
   */
  observeProductForm() {
    const productForm = document.querySelector('product-form');

    const observer = new IntersectionObserver(([{ isIntersecting }]) => {
      this.classList.toggle('translate-y-0', !isIntersecting);
      this.classList.toggle('translate-y-full', isIntersecting);
      this.classList.toggle('opacity-0', isIntersecting);
    });

    observer.observe(productForm);
  }
}

customElements.define('sticky-add-to-cart', StickyAddToCart);
